module.exports = __webpack_public_path__ + "static/media/logo.d286cd16.png";